<form id="inputForm" [formGroup]="inputForm" (ngSubmit)="submit()">
  <div class="row text-center justify-content-center mt-3">
    <div class="col-12 col-sm-8 col-md-6">
      <mat-form-field class="w-100" appearance="fill">
        <textarea matInput formControlName="value" autofocus="true" autocomplete="off" required [rows]="4"></textarea>
      </mat-form-field>
    </div>
  </div>
</form>
